// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "hashed-1/" + (chunkId === 20071 ? "griffel" : chunkId) + "-" + {20071: "fad37893bb",47577: "81d35eec74",}[chunkId] + ".css"
}